import React from 'react';
import OrganisationInventory from '../organisation-inventory';

const InventoryTab = props => (
  <div>
    <OrganisationInventory {...props} />
  </div>
);

export default InventoryTab;



/** WEBPACK FOOTER **
 ** ./src/containers/team-manager/inventory-tab.js
 **/